module.exports = {"450102001":"民生街道","450102002":"朝阳街道","450102003":"兴东街道","450102101":"三塘镇","450102102":"五塘镇","450102104":"昆仑镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450102.json
// module id = 2195
// module chunks = 0